import React, { useEffect, useState, useRef } from "react";
import style from "../../style/AddDataBodyInput.module.scss";
import { FormControl } from "@mui/material";
import { MenuItem } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import { TextField } from "@mui/material";
import { Checkbox } from "@mui/material";
import { FormLabel } from "@mui/material";
import { Radio } from "@mui/material";
import { RadioGroup } from "@mui/material";
import { FormControlLabel } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { DateTimePicker } from "@mui/x-date-pickers";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "../../style/Other.css";
import Upload from "../Upload";
import { useNavigate } from "react-router-dom";

const CssTextField = styled((props) => <TextField {...props} fullWidth />)(
  ({ theme }) => ({
    "& .MuiFilledInput-root": {
      border: "1px solid #e2e2e1",
      overflow: "hidden",
      borderRadius: 4,
      backgroundColor: theme.palette.mode === "light" ? "#fcfcfb" : "#2b2b2b",
      transition: theme.transitions.create([
        "border-color",
        "background-color",
        "box-shadow",
      ]),
      "&:hover": {
        backgroundColor: "transparent",
      },
      "&:hover:not(.Mui-disabled):before": {
        borderBottom: "none",
      },
      "&:before": {
        border: "none",
      },
      "&:after": {
        border: "none",
      },
      "&.Mui-focused": {
        backgroundColor: "transparent",
        boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-error": {
        borderColor: "#EB4D3D",
      },
    },
  })
);

const modules = {
  toolbar: [["bold", "italic", "underline", "strike"], [{ list: "bullet" }]],
};

function AddDataBodyInput({ setSendData, setSendMediaData }) {
  const navigate = useNavigate();

  const [hospital, setHospital] = useState("");
  const [hospitalName, setHospitalName] = useState("");
  const [hospitalCode, setHospitalCose] = useState("");
  const [identity, setIdentity] = useState("");
  const [name, setName] = useState("");
  const [nameCheckBox, setNameCheckBox] = useState(false);
  const [date, setDate] = useState(null);
  const [gender, setGender] = useState(0);
  const [pastHistory, setPastHistory] = useState("");
  const [chiefComplaint, setChiefComplaint] = useState("");
  const [erTriageTime, setErTriageTime] = useState(null);
  const [onsetTime, setOnsetTime] = useState(null);
  const [PermorbidMRS, setPermorbidMRS] = useState("");
  const [nihss, setNihss] = useState("");
  const [renalFunction, setRenalFunction] = useState("");
  const [message, setMessage] = useState("");
  const [rtpa, setRtpa] = useState(null);
  const [hitTime, setHitTime] = useState(null);
  const [dot, setDot] = useState(null);
  const [screen, setScreen] = useState(0);
  const [weight, setWeight] = useState("");
  const [imageOrVideo, setImageOrVideo] = useState(null);
  // console.log(renalFunction);

  const [chiefComplaintWordCount, setChiefComplaintWordCount] = useState(0);
  const [pastHistoryWordCount, setPastHistoryWordCount] = useState(0);
  const [messageWordCount, setMessageWordCount] = useState(0);
  const [selfIdentities, setSelfIdentities] = useState([]);
  //console.log(selfIdentities);

  const [identityError, setIdentitlyError] = useState(false);
  const editorRef = useRef(null);

  const sendData = {
    isUnKnown: nameCheckBox,
    Name: name,
    BirthDate: date?.$d,
    Sex: +gender,
    IdNo: identity,
    PastHistory: pastHistory,
    ChiefComplaint: chiefComplaint,
    OnsetTime: onsetTime?.$d,
    ErTriageDateTime: erTriageTime?.$d,
    PremorbidMrs: PermorbidMRS === "" ? null : +PermorbidMRS,
    RenalFunction: renalFunction === "" ? null : +renalFunction,
    Nihss: nihss === "" ? null : +nihss,
    IsRtpa: rtpa === null ? null : +rtpa ? true : false,
    InjectDateTime: hitTime?.$d,
    InjectDose: +dot === 0 ? null : +dot,
    IsCovid19: +screen,
    RowId: null,
    Content: message,
    Weight: weight === "" ? null : +weight,
    HasImageOrVideo: imageOrVideo?.length > 0 ? true : false,
  };

  useEffect(() => {
    setHospitalName(JSON.parse(localStorage.getItem("auth"))?.Hospital);
    setHospitalCose(JSON.parse(localStorage.getItem("auth"))?.HospitalCode);
    setSelfIdentities(JSON.parse(localStorage.getItem("auth"))?.SelfIdentities);
  }, []);
  useEffect(() => {
    setHospital(hospitalCode);
  }, [hospitalCode]);
  useEffect(() => {
    if (selfIdentities?.length > 0) {
      alert("無新增權限");
      navigate("/ReferralDataList");
    }
  }, [selfIdentities]);

  useEffect(() => {
    setSendData(sendData);
    setSendMediaData(imageOrVideo);
  }, [
    nameCheckBox,
    name,
    date?.$d,
    gender,
    identity,
    pastHistory,
    chiefComplaint,
    onsetTime?.$d,
    erTriageTime?.$d,
    PermorbidMRS,
    renalFunction,
    nihss,
    rtpa,
    hitTime,
    dot,
    screen,
    message,
    weight,
    imageOrVideo,
  ]);

  const handleHospitalChange = (e) => {
    setHospital(e.target.value);
  };
  const handleIdentityChange = (e) => {
    setIdentity(e.target.value);
  };
  const handleNameChange = (e) => {
    setName(e.target.value);
  };
  const handleChange = (e) => {
    setNameCheckBox(e.target.checked);
  };

  const handleDataChange = (newValue) => {
    setDate(newValue);
  };

  const handleGenderChange = (e) => {
    setGender(e.target.value);
  };

  const handlePastHistory = (e) => {
    const inputValue = e.target.value;

    let chineseCount = 0;
    let englishCount = 0;
    const characters = inputValue.split("");

    characters.forEach((char) => {
      if (char.trim().match(/[\u4e00-\u9fa5]+|[^\s\u4e00-\u9fa5]+/g)) {
        chineseCount++;
      } else {
        const englishRegex = /^[A-Za-z]+$/;
        if (englishRegex.test(char)) {
          englishCount++;
        }
      }
    });

    if (chineseCount + englishCount <= 600) {
      setPastHistory(inputValue);
      setPastHistoryWordCount(chineseCount + englishCount);
    }
  };

  const handleChiefComplaint = (e) => {
    const inputValue = e.target.value;

    let chineseCount = 0;
    let englishCount = 0;
    const characters = inputValue.split("");

    characters.forEach((char) => {
      if (char.trim().match(/[\u4e00-\u9fa5]+|[^\s\u4e00-\u9fa5]+/g)) {
        chineseCount++;
      } else {
        const englishRegex = /^[A-Za-z]+$/;
        if (englishRegex.test(char)) {
          englishCount++;
        }
      }
    });

    if (chineseCount + englishCount <= 600) {
      setChiefComplaint(inputValue);
      setChiefComplaintWordCount(chineseCount + englishCount);
    }
  };
  const handleErTriageDataTimeChange = (newValue) => {
    setErTriageTime(newValue);
  };
  const handleDataTimeChange = (newValue) => {
    setOnsetTime(newValue);
  };
  const handlePermorbidMRSChange = (e) => {
    setPermorbidMRS(e.target.value);
  };
  const handleNihssChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue === "") {
      setNihss("");
    } else if (
      isNaN(inputValue) ||
      parseFloat(inputValue) !== parseInt(inputValue, 10)
    ) {
      alert("NIHSS請輸入整數");
      setNihss("");
    } else if (inputValue >= 42) {
      setNihss(42);
    } else if (inputValue <= 0) {
      setNihss("");
    } else {
      const removeDot = inputValue.replace(".", "");
      setNihss(removeDot);
    }
  };
  // console.log(nihss);
  const handleRenalFunctionChange = (e) => {
    if (
      /^(?!^\.)(?!0\d)\d*(\.\d{0,2})?$/.test(e.target.value) &&
      e.target.value >= 0 &&
      e.target.value <= 99.99
    ) {
      setRenalFunction(e.target.value);
    } else if (e.target.value <= 0) {
      setRenalFunction("");
    }
  };
  const handleRtpaChange = (e) => {
    setRtpa(e.target.value);
  };
  const handleHitTimeChange = (newValue) => {
    setHitTime(newValue);
  };
  const handleDotChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue === "") {
      setDot("");
    } else if (
      isNaN(inputValue) ||
      parseFloat(inputValue) !== parseInt(inputValue, 10)
    ) {
      alert("總劑量請輸入整數");
      setDot("");
    } else if (inputValue >= 90) {
      setDot(90);
    } else if (inputValue <= 0) {
      setDot("");
    } else {
      const removeDot = inputValue.replace(".", "");
      setDot(removeDot);
    }
  };
  const handleWeightChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue === "") {
      setWeight("");
    } else if (
      isNaN(inputValue) ||
      parseFloat(inputValue) !== parseInt(inputValue, 10)
    ) {
      alert("體重請輸入整數");
      setWeight("");
    } else if (inputValue >= 150) {
      setWeight(150);
    } else if (inputValue <= 0) {
      setWeight("");
    } else {
      const removeDot = inputValue.replace(".", "");
      setWeight(removeDot);
    }
  };
  const handleScreenChange = (e) => {
    setScreen(e.target.value);
  };
  const handleMessageChange = (content, delta, source, editor) => {
    const textValue = editorRef.current?.value || "";
    // console.log(content);
    let chineseCount = 0;
    let englishCount = 0;
    const characters = textValue.split("");

    characters.forEach((char) => {
      if (char.trim().match(/[\u4e00-\u9fa5]+|[^\s\u4e00-\u9fa5]+/g)) {
        chineseCount++;
      } else {
        const englishRegex = /^[A-Za-z]+$/;
        if (englishRegex.test(char)) {
          englishCount++;
        }
      }
    });

    if (chineseCount + englishCount <= 600) {
      setMessage(content);
      setMessageWordCount(chineseCount + englishCount);
    }

    if (messageWordCount > 600) {
      const maxAllowedWords = textValue.split(/\s+/, 600).join(" ");
      editorRef.current?.setMessage(maxAllowedWords);
      setMessage(maxAllowedWords);
      setMessageWordCount(600);
    }
  };

  const identityRegex = /^[A-Z|a-z]{1}[1-2]{1}[0-9]{8}$/;
  //onBlur
  const handleIdentityBlur = (e) => {
    const input = e.target.value;
    // 20251201 移除檢核
    // setIdentitlyError(!identityRegex.test(input));
  };
  //console.log(identityError);
  const handleKeyDown = (event) => {
    let mobile = "";
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      mobile = "ios";
    } else if (/(Android)/i.test(navigator.userAgent)) {
      mobile = "android";
    } else {
      mobile = "desktop";
    }

    if (mobile === "ios" || mobile === "desktop") {
      if (event.code === "Period" || event.code === "NumpadDecimal") {
        alert("請輸入整數");
      }
    } else if (mobile === "android") {
      if (event.key === "Unidentified") {
        alert("請輸入整數");
      }
    }
  };

  return (
    <div className={style.container}>
      <div className={style.top_container}>
        <div className={style.title} id="one">
          轉介個案資訊
        </div>
        <div className={style.fist_line}>
          <div className={style.hospital_box}>
            <CssTextField
              label="轉出醫院"
              select
              variant="filled"
              onChange={handleHospitalChange}
              value={hospital}
              disabled={false}
            >
              <MenuItem value={hospital} style={{ fontSize: "10px" }} disabled>
                請選擇轉出醫院
              </MenuItem>
              <MenuItem value={hospital} style={{ fontSize: "10px" }}>
                {hospitalName}
              </MenuItem>
            </CssTextField>
          </div>
          <div className={style.identity_box}>
            <CssTextField
              label="請輸入個案身分證字號"
              variant="filled"
              onChange={handleIdentityChange}
              value={identity}
              style={{ width: "100%" }}
              onBlur={handleIdentityBlur}
              error={identityError}
            />
          </div>
        </div>
        <div className={style.second_line}>
          <div className={style.name_box}>
            <CssTextField
              label="輸入個案姓名"
              variant="filled"
              onChange={handleNameChange}
              value={name}
              style={{ width: "100%" }}
            />
          </div>
          <div className={style.name_checkbox}>
            <Checkbox
              size="small"
              checked={nameCheckBox}
              onChange={handleChange}
              inputProps={{ "aria-label": "controlled" }}
              sx={{
                color: "#ccc",
                "&.Mui-checked": {
                  color: "#057aff",
                },
              }}
            />
            無法確認個案姓名
          </div>
        </div>
        <div className={style.third_line}>
          <div className={style.date_box}>
            <DesktopDatePicker
              label="輸入個案生日"
              inputFormat="yyyy/MM/dd"
              value={date}
              onChange={handleDataChange}
              sx={{ width: "100%" }}
              renderInput={(params) => (
                <CssTextField {...params} variant="filled" />
              )}
            />
          </div>
          <div className={style.gender_box}>
            <FormControl fullWidth>
              <FormLabel
                style={{
                  fontSize: "10px",
                  color: "rgba(0, 0, 0, 0.6)",
                  position: "absolute",
                  top: "5px",
                  left: "8px",
                  background: "transparent",
                }}
              >
                個案性別
              </FormLabel>
              <RadioGroup
                row
                style={{ paddingLeft: "50px", paddingTop: "12px" }}
                onChange={handleGenderChange}
              >
                <FormControlLabel
                  value={1}
                  control={<Radio size="small" />}
                  label="男生"
                />
                <FormControlLabel
                  value={2}
                  control={<Radio size="small" />}
                  label="女生"
                />
              </RadioGroup>
            </FormControl>
          </div>
        </div>
        <div className={style.third_line}>
          <div className={style.onsetTime_box}>
            <DateTimePicker
              label="急診檢傷時間"
              inputFormat="yyyy/MM/dd HH:mm"
              value={erTriageTime}
              onChange={handleErTriageDataTimeChange}
              sx={{ width: "100%" }}
              renderInput={(params) => (
                <CssTextField {...params} variant="filled" />
              )}
            />
          </div>
        </div>
        <div className={style.four_line}>
          <div className={style.past_history}>
            <CssTextField
              label="Past History"
              multiline
              rows={5}
              variant="filled"
              style={{ width: "100%" }}
              value={pastHistory}
              onChange={handlePastHistory}
              helperText={`${pastHistoryWordCount}/600 words`}
            />
          </div>
        </div>
        <div className={style.five_line}>
          <div className={style.chief_complaint}>
            <CssTextField
              label="Chief Complaint"
              multiline
              rows={5}
              variant="filled"
              style={{ width: "100%" }}
              value={chiefComplaint}
              onChange={handleChiefComplaint}
              helperText={`${chiefComplaintWordCount}/600 words`}
            />
          </div>
        </div>
        <div className={style.six_line}>
          <div className={style.onsetTime_box}>
            <DateTimePicker
              label="onset time"
              inputFormat="yyyy/MM/dd HH:mm"
              value={onsetTime}
              onChange={handleDataTimeChange}
              sx={{ width: "100%" }}
              renderInput={(params) => (
                <CssTextField {...params} variant="filled" />
              )}
            />
          </div>
          <div className={style.premorbidMRS_box}>
            <CssTextField
              label="Premorbid MRS"
              select
              variant="filled"
              onChange={handlePermorbidMRSChange}
              value={PermorbidMRS}
              style={{ width: "100%" }}
            >
              <MenuItem
                value={PermorbidMRS}
                style={{ fontSize: "14px" }}
                disabled
              >
                請選擇0-5
              </MenuItem>
              {Array(6)
                .fill(6)
                .map((v, i) => {
                  return (
                    <MenuItem value={i} style={{ fontSize: "14px" }} key={i}>
                      {i}
                    </MenuItem>
                  );
                })}
            </CssTextField>
          </div>
        </div>
        <div className={style.seven_line}>
          <div className={style.NIHSS_box}>
            <CssTextField
              label="NIHSS"
              onChange={handleNihssChange}
              onKeyDown={handleKeyDown}
              value={nihss}
              placeholder="請輸入(1-42)"
              variant="filled"
              style={{ width: "100%" }}
              InputProps={{
                inputProps: {
                  min: 1,
                  max: 42,
                  inputMode: "numeric",
                },
              }}
            />
          </div>
          <div className={style.RenalFumction_box}>
            <CssTextField
              label="Renal function(Cr. Data)"
              onChange={handleRenalFunctionChange}
              value={renalFunction}
              placeholder="最大可輸入99.99"
              variant="filled"
              style={{ width: "100%" }}
              InputProps={{
                inputProps: {
                  min: 1,
                  max: 100,
                  inputMode: "decimal",
                },
              }}
            />
          </div>
        </div>
        <div className={style.eight_line}>
          <div className={style.rtpa_box}>
            <FormControl
              style={{
                display: "flex",
                justifyContent: "center",
              }}
              fullWidth
            >
              <FormLabel
                style={{
                  fontSize: "10px",
                  color: "rgba(0, 0, 0, 0.6)",
                  position: "absolute",
                  top: "5px",
                  left: "8px",
                  background: "transparent",
                }}
              >
                rt-PA(+/-)
              </FormLabel>
              <RadioGroup
                row
                style={{ paddingLeft: "50px", paddingTop: "12px" }}
                onChange={handleRtpaChange}
              >
                <FormControlLabel
                  value={0}
                  control={<Radio size="small" />}
                  label="無"
                />
                <FormControlLabel
                  value={1}
                  control={<Radio size="small" />}
                  label="有"
                />
              </RadioGroup>
              <div
                style={{
                  display: +rtpa ? "block" : "none",
                  width: "100%",
                  padding: "10px",
                }}
              >
                <DateTimePicker
                  label="施打時間"
                  inputFormat="yyyy/MM/dd HH:mm"
                  value={hitTime}
                  onChange={handleHitTimeChange}
                  sx={{ width: "100%" }}
                  renderInput={(params) => (
                    <CssTextField {...params} variant="filled" />
                  )}
                />
                <CssTextField
                  label="總劑量(mg)"
                  variant="filled"
                  onChange={handleDotChange}
                  value={dot}
                  style={{ width: "100%", marginTop: "10px" }}
                  placeholder="請輸入(1-90)"
                  onKeyDown={handleKeyDown}
                  InputProps={{
                    inputProps: {
                      type: "number",
                      inputMode: "numeric",
                    },
                  }}
                />
              </div>
            </FormControl>
          </div>
          <div className={style.screen_box}>
            {/* <FormControl fullWidth>
              <FormLabel
                style={{
                  fontSize: "10px",
                  color: "rgba(0, 0, 0, 0.6)",
                  position: "absolute",
                  top: "5px",
                  left: "8px",
                  background: "transparent",
                }}
              >
                快篩結果
              </FormLabel>
              <RadioGroup
                row
                style={{ paddingLeft: "50px", paddingTop: "12px" }}
                onChange={handleScreenChange}
              >
                <FormControlLabel
                  value={2}
                  control={<Radio size="small" />}
                  label="陰性"
                />
                <FormControlLabel
                  value={1}
                  control={<Radio size="small" />}
                  label="陽性"
                />
                <FormControlLabel
                  value={3}
                  control={<Radio size="small" />}
                  label="檢驗中"
                />
              </RadioGroup>
            </FormControl> */}
             <CssTextField
              label="體重(kg)"
              onChange={handleWeightChange}
              onKeyDown={handleKeyDown}
              value={weight}
              placeholder="請輸入(1-150)"
              variant="filled"
              style={{ width: "100%" }}
              InputProps={{
                inputProps: {
                  type: "number",
                  inputMode: "numeric",
                },
              }}
            />
          </div>
        </div>
        {/* <div className={style.nine_line}>
          <div className={style.RenalFumction_box}>
           
          </div>
        </div> */}
      </div>
      <div className={style.bottom_container} id="two">
        <div className={style.title}>病情留言板</div>
        <div className={style.upload_box}>
          <Upload setImageOrVideo={setImageOrVideo} />
        </div>
        <ReactQuill
          theme="snow"
          value={message}
          onChange={handleMessageChange}
          className={style.message_box}
          modules={modules}
          ref={editorRef}
        />
      </div>
    </div>
  );
}

export default AddDataBodyInput;
